import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component BellOffSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <BellOffSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <BellOffSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const BellOffSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      data-testid="BellOffSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M8 11v1H4v-1zM1.414.707l9.9 9.9-.707.707L9.293 10H2V5c0-.665.162-1.292.45-1.843L.706 1.414zm1.591 4.117L3 5v4h5.293l-5.09-5.09c-.11.286-.18.593-.198.914M7 0v1.126c1.725.444 3 2.01 3 3.874v2.9l-1-1V5a3 3 0 0 0-2.824-2.995L6 2c-.546 0-1.058.146-1.499.4l-.726-.725A4 4 0 0 1 5 1.126L5 0z"
      />
    </svg>
  )
);
BellOffSmallIcon.displayName = "BellOffSmallIcon";
export default BellOffSmallIcon;
